module.exports = __webpack_public_path__ + "img/account-subscription-img.fb293eae.svg";